// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cdff6886","333":"9499250e","522":"6c64006d","540":"4f75bcd1","672":"a1eed962","798":"60980f35","828":"858e064a"}[chunkId] + ".chunk.js";
};